import Axios from "../../utils/axios";

export const readCurriculum = (payload) => {
    const URL = "/curriculum/read";
    return Axios.post(URL, payload).then((res) => res.data);
};

export const readHomeCurriculum = (payload) => {
    const URL = "/curriculum/readhome";
    return Axios.post(URL, payload).then((res) => res.data);
};

export const saveChurchCurriculum = (payload) => {
  const URL = "/churches/curriculum/save";
  return Axios.post(URL, payload).then((res) => res.data);
};
export const deleteChurchCurriculum = (payload) => {
    const URL = "/churches/curriculum/delete";
    return Axios.post(URL, payload).then((res) => res.data);
  };
  export const saveChurchJournal = (payload) => {
    const URL = "/churches/journals/save";
    return Axios.post(URL, payload).then((res) => res.data);
  };
  